import { Button, Image, Modal, Card, Row, Col } from "antd"
import { PiDownloadSimpleDuotone } from "react-icons/pi";
import { IoEyeOutline } from "react-icons/io5";
import api from "../../../config/Config"
import { FilePdfOutlined, FileImageOutlined, FileUnknownOutlined, FileWordOutlined, FileExcelOutlined } from '@ant-design/icons';
import { docs1 } from "../../../components/icons";
const { Meta } = Card;

const getFileIcon = (fileName: any) => {
    if (!fileName) {
        return <FileUnknownOutlined style={{ fontSize: '48px', color: '#8c8c8c' }} />;
    }

    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
        case 'pdf':
            return <FilePdfOutlined style={{ fontSize: '48px', color: '#FF0000' }} />;
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
            return <FileImageOutlined style={{ fontSize: '48px', color: '#1890ff' }} />;
        case 'doc':
        case 'docx':
            return <FileWordOutlined style={{ fontSize: '48px', color: '#1890ff' }} />;
        case 'xls':
        case 'xlsx':
            return <FileExcelOutlined style={{ fontSize: '48px', color: '#52c41a' }} />;
        default:
            return <FileUnknownOutlined style={{ fontSize: '48px', color: '#8c8c8c' }} />;
    }
};

const downloadFile = async (url: string, fileName: string) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href); // Clean up
    } catch (error) {
        console.error("Error downloading file:", error);
    }
};

const DocsCard = ({ isModalOpen, handleOk, handleCancel, idFront, chefDocumentScan }: any) => {
    const downloadUrl = (fileName: string) => `${fileName}`;


    return (
        <Modal
            title="Docs"
            open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
            footer={null}
            width={1500}
            style={{ top: 100 }}
            bodyStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
        >

            <div>
                <div className=" p-2 form-label rounded-sm" role="alert" style={{ backgroundColor: '#F0F3F8' }}>
                    List of documents and membership cards
                </div>

                <div>
                    <h5>Type of document</h5>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                            
                                {
                                idFront && idFront?.map((item: any, index: number) => (
                                <div className="col-md-6" key={index} style={{ marginBottom: '20px' }}>
                                        <p>Type: {item.type}</p>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div >
                                                            <Image src={api.var_.url_avatar + item.front} alt={`Front of ID ${index}`} style={{ width: '200px', height: 'auto' }} /><br />
                                                            <div style={{ display: 'flex', marginTop:2  }}>
                                                                <PiDownloadSimpleDuotone
                                                                    style={{ color: '1576ED', width: 30, height: 30 }}
                                                                    onClick={() => downloadFile(downloadUrl(api.var_.url_avatar + item.front), item.type)}
                                                                />

                                                                <Button href={api.var_.url_avatar + item.front} download={`ID-Front-${index}`} target="blank" style={{ marginLeft: '10px' }}>
                                                                    <IoEyeOutline style={{ color: '1576ED' }} />
                                                                </Button>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div style={{ marginTop: '10px' }}>
                                                            <Image src={api.var_.url_avatar + item.back} alt={`Back of ID ${index}`} style={{ width: '200px', height: 'auto' }} /><br />
                                                            <div style={{ display: 'flex', marginTop:2 }}>
                                                                <PiDownloadSimpleDuotone
                                                                    style={{ color: '1576ED', width: 30, height: 30 }}
                                                                    onClick={() => downloadFile(downloadUrl(api.var_.url_avatar + item.back), item.back)}
                                                                />
                                                                <Button href={api.var_.url_avatar + item.back} download={`ID-Back-${index}`} target="blank" style={{ marginLeft: '10px' }}>
                                                                    <IoEyeOutline style={{ color: '1576ED' }} />
                                                                </Button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    </div>

                                ))}
                            </div>
                        </div>
                    </div>





                    {/* <h2>Docs:</h2> */}
                    {/* <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                {chefDocumentScan.map((doc: any, index: number) => (
                                    <div className="col-md-6" key={index} style={{ marginBottom: '20px' }}>
                                        <div style={{ display: 'flex', margin: 10 }}>
                                            <p style={{ marginRight: 10, fontWeight: 'bold' }}>Name: {doc.name}</p>
                                            <p style={{ fontWeight: 'bold' }}>Number: {doc.number}</p>
                                        </div>
                                        <div style={{ width: '100%', height: '500px', overflow: 'auto', border: '1px solid #F1F1F1' }}>
                                            <iframe
                                                src={api.var_.url_avatar + doc.file_name}
                                                style={{ width: '100%', height: '100%', border: 'none' }}
                                                title={`PDF document ${doc.number}`}

                                            />
                                        </div>

                                        <Button type="primary" href={api.var_.url_avatar + doc.file_name} download style={{ marginTop: '10px' }}>
                                            Download {doc.name}
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div> */}

                    {/* {chefDocumentScan.map((doc: any, index: number) => (
                        <Col span={8} key={index}>
                            <Card
                                hoverable
                                cover={getFileIcon(doc.file_name)}
                                actions={[
                                    <Button type="primary" href={doc.file_name} download>Download {doc.file_name}</Button>
                                ]}
                            >
                                <Meta title={doc.name} description={`Number: ${doc.number}`} />
                            </Card>
                        </Col>
                    ))} */}

                    <div className="table-responsive mt-3">
                        <table
                            className="table header-border table-responsive-sm tbl-common"
                        >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th style={{ alignItems: 'center', justifyContent: 'center' }}>DownLoad</th>
                                    <th>Show</th>
                                </tr>
                            </thead>
                            <tbody>
                                {chefDocumentScan !== "null" && chefDocumentScan?.length > 0 ? (
                                   chefDocumentScan !== "null" && chefDocumentScan?.map((doc: any, index: number) => (
                                        <tr key={index} className="cursor-pointer" data-toggle="collapse" data-target="#demo5">
                                            <td>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <div title="contact-img">
                                                        {getFileIcon(api.var_.url_avatar + doc.file_name)}
                                                    </div>
                                                    <div>
                                                        <div>{doc.name}</div>
                                                        <div>{doc.number}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                <div>
                                                    <PiDownloadSimpleDuotone
                                                        style={{ color: '1576ED', width: 35, height: 35 }}
                                                        onClick={() => downloadFile(downloadUrl(api.var_.url_avatar + doc.file_name), doc.name)}
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <Button
                                                        style={{ justifyContent: 'center' }}
                                                        href={api.var_.url_avatar + doc.file_name}
                                                        download={doc.name}
                                                        target="_blank"
                                                    >
                                                        <IoEyeOutline style={{ color: '1576ED' }} />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: 'center', padding: '20px' }}>
                                            <img src={docs1} style={{ width: 45, height: 45 }} /><br />
                                            No documents available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </Modal>
    )
}

export default DocsCard